module.exports = __webpack_public_path__ + "img/brand-popular-models-cjdr.64db02c2.png";